import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { BackIcon } from '../../Svg/Index.js'
import { SET_TYPE, SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { GET_USERS } from '../../Actions/User'
import AddFriendButton from '../Buttons/AddFriendButton'


const debounce = (fn, time) => {
    let timeout;
    return function() {
      const functionCall = () => fn.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    }
}
class MemberOverview extends Component {

    state = {
        searchQuery: '',
    }

    componentDidMount() {
        this.props.actions.GET_USERS()
    }

    changeType = (type) => {
        this.props.actions.SET_TYPE(type)
    }

    showProfile = (e, userId) => {
        if(e.target.classList.contains('c-btn')) return;
        this.props.actions.SET_PROFILE_OPEN(userId);
    }

    handleSearch = (q)=> {
        this.setState({
            searchQuery: this.refs.filter.value
        })
    }

    render() {
        const { searchQuery } = this.state;

        let sentRequests = this.props.user.sent_friend_requests.map(r => {
            return r.friend;
        });

        let allUsers = [...sentRequests, ...this.props.user.friends.map(r => { return {...r, alreadyFriends: true }}) ,...this.props.users];

        const users = allUsers.filter(r => !!r).filter(r => {
            if(this.state.searchQuery.length <2) return true;
            let searchQuery = this.state.searchQuery.toLowerCase();                    
            return (r?.city?.toLowerCase().includes(searchQuery)) || r.display_name.toLowerCase().includes(searchQuery) || r.username.toLowerCase().includes(searchQuery)
        })
            

        return (
            <div className="c-sidebar-overlay">
                <div className="c-sidebar-overlay__inner">
                    <button className="c-btn c-btn--back" onClick={ () => this.changeType('') }>
                        <BackIcon />
                    </button>

                    <h2 className="c-sidebar-overlay__title">Ledenoverzicht</h2>
                    <input className="o-search" placeholder="Zoek op naam of woonplaats..." type="text" ref="filter" 
                        onChange={debounce(text => {
                            this.handleSearch(text)
                        }, 500)} 
                    />

                    <ul className="c-list">
                        {
                            users.map((item, i) => 
                                item && (
                                    <li className="c-list__item" onClick={(e) => this.showProfile(e, item._id)} key={`user-${item._id}}`}>
                                        <div className="c-list-user">
                                            <div className="c-list-avatar" style={{backgroundImage: `url(${item.avatar.user_avatar})`}}>
                                            </div>
                                            <span className="c-list-user__name">{item.display_name}</span>
                                            <AddFriendButton friendId={item._id} />
                                        </div>
                                    </li>
                                )
                            )
                        }
                        
                    </ul>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        users: state.users.list,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_TYPE, SET_PROFILE_OPEN, GET_USERS}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberOverview)